import { render, staticRenderFns } from "./VideoButtonView.vue?vue&type=template&id=5e459d68"
import script from "./VideoButtonView.vue?vue&type=script&lang=js"
export * from "./VideoButtonView.vue?vue&type=script&lang=js"
import style0 from "./VideoButtonView.vue?vue&type=style&index=0&id=5e459d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports